﻿module Client.ContractPage.ChangeOrders.Main

open Feliz
open PortalLibs.Client
open PortalLibs.Client.Util
open PortalLibs.Shared
open Model
open Client.ContractPage.ChangeOrders
open Shared.Models
open Lines
open Items

let View changeOrders items lines (contract: Contract) =
  let orderView (orders: ChangeOrderHeader list) =
    React.fragment [
      
      let lineFactory itemId = LinesTable {| Lines = lines; ItemId = itemId |}
      let itemFactory header = ItemsTable {| Items = items; Header = header; ChildrenLines = lineFactory |}
      
      let grouped = orders |> List.groupBy (fun x -> x.Type)
      let get expType = grouped |> List.where(fun (t,_) -> t = expType) |> List.map snd |> List.concat
      
      Headers.View (get ChangeOrderType.Approved) ChangeOrderType.Approved itemFactory
      Headers.View (get ChangeOrderType.Pending) ChangeOrderType.Pending itemFactory
    ]
    
  loadingMessageOrContent
    "Loading change orders..."
    orderView
    (Map.tryFind contract.Id changeOrders) 